import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { googleReviews, GOOGLE_REVIEW_URL } from '../reviewsData';

const Stars = () => (
  <div className="flex items-center gap-0.5">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" />
    ))}
  </div>
);

// Real Google reviews section — 5.0 rating badge (count intentionally not displayed)
const GoogleReviews = ({ limit = 6 }) => (
  <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-testid="google-reviews-section">
    <div className="container mx-auto">
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-3 bg-gray-50 border-2 border-gray-200 rounded-full px-6 py-3 mb-6" data-testid="google-rating-badge">
          <svg viewBox="0 0 24 24" className="w-6 h-6" aria-hidden="true"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 0 0 1 12c0 1.77.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
          <span className="text-2xl font-bold text-gray-900">5.0</span>
          <Stars />
          <span className="text-gray-600 font-medium">Google Rating</span>
        </div>
        <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">What Our Clients Say</h2>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">Real, verified Google reviews from homeowners and businesses across Southwest Florida</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {googleReviews.slice(0, limit).map((r) => (
          <Card key={r.id} className="bg-white border-2 border-gray-200 hover:border-brand-gold hover:shadow-xl transition-all duration-300 h-full" data-testid={`google-review-${r.id}`}>
            <CardContent className="pt-6 flex flex-col h-full">
              <div className="flex items-center justify-between mb-3">
                <Stars />
                <svg viewBox="0 0 24 24" className="w-5 h-5 opacity-70" aria-hidden="true"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 0 0 1 12c0 1.77.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
              </div>
              <p className="text-gray-700 mb-4 flex-grow">"{r.text}"</p>
              <div className="flex items-center justify-between">
                <span className="font-bold text-gray-900">{r.name}</span>
                <Badge variant="outline" className="border-brand-gold text-brand-gold text-xs">{r.project}</Badge>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="text-center mt-10">
        <a href={GOOGLE_REVIEW_URL} target="_blank" rel="noopener noreferrer" data-testid="google-reviews-link">
          <Button size="lg" variant="outline" className="border-2 border-brand-gold text-brand-gold hover:bg-brand-gold hover:text-brand-black font-bold">
            See Us on Google — Leave a Review
          </Button>
        </a>
      </div>
    </div>
  </section>
);

export default GoogleReviews;
